import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {FamilyMemberStats} from "./Statistics";
import {GetCurrentStats, UploadMember} from "./S3Service";
import johannes_neutral from "./images/Johannes_neutral.jpg"
import johannes_glad from "./images/Johannes_glad.jpg"
import johannes_sur from "./images/Johannes_sur.jpg"
import kaggen_neutral from "./images/Kaggen_neutral.jpg"
import kaggen_glad from "./images/Kaggen_glad.jpg"
import kaggen_sur from "./images/Kaggen_sur.jpg"
import wanja_neutral from "./images/Wanja_neutral.jpg"
import wanja_glad from "./images/Wanja_glad.jpg"
import wanja_sur from "./images/Wanja_sur.jpg"
import hedda_neutral from "./images/Hedda_neutral.jpg"
import hedda_glad from "./images/Hedda_glad.jpg"
import hedda_sur from "./images/Hedda_sur.jpg"
import {CardHeader} from "@material-ui/core";
import { Alert, AlertTitle } from '@material-ui/lab';

const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 140,
    },
});

type Props = {
    name: string
}

type Alert = {
    message: string,
    severity: string,
    created: number
}

export default function FamilyMember( { name } : Props) {
    const classes = useStyles();
    const [member, setMember] = useState<FamilyMemberStats>({unpaidFines : 0, totalFines : 0})
    const [currentImage, setCurrentImage] = useState<string>()
    const [happyImage, setHappyImage] = useState<string>()
    const [sadImage, setSadImage] = useState<string>()
    const [neutralImage, setNeutralImage] = useState<string>()
    // const [alertStatus, setAlertStatus] = useState<Alert | null>()
    const [alertStatus, setAlertStatus] = useState<Alert | null>()

    useEffect(() => {

        if (name === "Johannes") {
            setSadImage(johannes_sur)
            setNeutralImage(johannes_neutral)
            setHappyImage(johannes_glad)
            setCurrentImage(johannes_neutral)
        }
        if (name === "Kaggen") {
            setSadImage(kaggen_sur)
            setNeutralImage(kaggen_neutral)
            setHappyImage(kaggen_glad)
            setCurrentImage(kaggen_neutral)
        }
        if (name === "Hedda") {
            setSadImage(hedda_sur)
            setNeutralImage(hedda_neutral)
            setHappyImage(hedda_glad)
            setCurrentImage(hedda_neutral)
        }
        if (name === "Wanja") {
            setSadImage(wanja_sur)
            setNeutralImage(wanja_neutral)
            setHappyImage(wanja_glad)
            setCurrentImage(wanja_neutral)
        }

        GetCurrentStats(name).then(value => {
            console.log("XxX\n" + JSON.stringify(value))
            setMember(value)
        })
    }, [name])

    useEffect(() => {
        if (alertStatus) setTimeout(() => {
            if (alertStatus) setAlertStatus(null)
        }, 5000)
    }, [alertStatus])

    const addSwear = async () => {
        let stats = await GetCurrentStats(name);

        let newMember: FamilyMemberStats = {
            unpaidFines : stats.unpaidFines + 1,
            totalFines : stats.totalFines + 1
        }

        try {
            await UploadMember(name, newMember)
            setMember(newMember)
            setAlertStatus({message: "Sparad", severity: "success", created: new Date().getTime()})
        } catch (e) {
            setAlertStatus({message: "Något gick fel :(", severity: "error", created: new Date().getTime()})
        }

    }

    const pay = async () => {
        let stats = await GetCurrentStats(name);

        let newMember: FamilyMemberStats = {
            unpaidFines : 0,
            totalFines : stats.totalFines
        }

        try {
            await UploadMember(name, newMember)
            setMember(newMember)
            setAlertStatus({message: "Sparad", severity: "success", created: new Date().getTime()})
        } catch (e) {
            setAlertStatus({message: "Något gick fel :(", severity: "error", created: new Date().getTime()})
        }
    }

    return (
        <Card className={classes.root}>
            {alertStatus && alertStatus.severity === "success" &&
                <Alert severity="success">
                    {alertStatus.message}
                </Alert>
            }
            {alertStatus && alertStatus.severity === "error" &&
                <Alert severity="error">
                    {alertStatus.message}
                </Alert>
            }
            <CardActionArea>
                <CardMedia
                    className={classes.media}
                    image={currentImage}
                    title="Member"
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {name} är skyldig till {member.totalFines} svärisar! Varav {member.unpaidFines} är obetalda
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary" onClick={ () => addSwear() } onMouseEnter={() => setCurrentImage(sadImage)} onMouseLeave={() => setCurrentImage(neutralImage)}>
                    #&%&@@!!!
                </Button>
                <Button size="small" color="primary" onClick={ () => pay() } onMouseEnter={() => setCurrentImage(happyImage)} onMouseLeave={() => setCurrentImage(neutralImage)}>
                    Betala
                </Button>
            </CardActions>
        </Card>
    );
}
